<template>
  <router-view :key="$route.params.promo_id" />
</template>

<script>
export default {
  mounted() {
    this.$store.commit('adminPanel/setViewTitle', {
      depth: 0,
      title: `Promo Management`,
      to: { name: 'promo' },
    });
  },
};
</script>

<style></style>
